import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsVelomobileNormalMedium = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M30.27 13.28l-.14-.08a13.82 13.82 0 00-8.1-2.03l-6.33.38a6.963 6.963 0 00-5.97-3.38 13.732 13.732 0 00-6.77 1.79L.13 11.57l.3 1.72 3.34-1.89a11.898 11.898 0 012.41-1.03 3.242 3.242 0 003.25 3.17c.026 0-.63.037 12.69-.72a12.23 12.23 0 017.15 1.79l.13.08a1.624 1.624 0 01.16 2.65 8.42 8.42 0 01-4.83 1.81 3.828 3.828 0 00-7.47.02H3.14l-.88-5.01-1.53.86 1.02 5.81h2.52a3.819 3.819 0 007.459 0h5.53a3.829 3.829 0 007.48-.02 10.03 10.03 0 005.85-2.18 3.27 3.27 0 00-.32-5.35zM9.53 11.89a1.619 1.619 0 01-1.572-.973 1.589 1.589 0 01-.128-.637v-.29a10.994 10.994 0 011.9-.16 5.37 5.37 0 014 1.83l-4.2.23zM8 22.175a2.177 2.177 0 01-2.008-1.345h4.017a2.178 2.178 0 01-2.01 1.345zm13 0a2.17 2.17 0 112.005-1.344A2.168 2.168 0 0121 22.17v.005z"
        fill=""
      />
    </svg>
  )
);
SvgSportsVelomobileNormalMedium.defaultProps = {
  color: 'currentColor',
  size: 32,
  title: undefined,
  titleId: undefined
};
SvgSportsVelomobileNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsVelomobileNormalMedium;
